import { Box, Divider, Typography } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";

import { SupplierConfiguration, Action } from "./components";
import useCreateSupplier from "./hooks/useCreateSupplier";
import newSupplierResolver from "../../../../libs/form-validations/new-supplier";
import Breadcrumb from "./components/Breadcrumb";
import { useSupplier } from "../../../../hooks/query";
import { useNotification } from "../../../../hooks";

import { Alert } from "../../../../shared";

const INITIAL_VALUES = {
    Name: "",
    Description: "",
    Email: "",
    PhoneNumber: "",
    Address: "",
    City: "",
    Country: "",
    Website: "",
    LogoUrl: "",
};

export default function Create() {
    const { handleCreateSupplier, createSupplierSvc } = useCreateSupplier();
    const { useList } = useSupplier();
    const { showError } = useNotification();
    const { data: suppliersData } = useList();

    const methods = useForm({
        resolver: newSupplierResolver,
        defaultValues: INITIAL_VALUES,
        mode: "onChange",
    });

    const onSubmit = methods.handleSubmit(async (data) => {
        // Check for duplicate supplier name
        const existingSuppliers = (suppliersData as any[]) || [];
        const isDuplicate = existingSuppliers.some(
            (supplier) => supplier.Name.toLowerCase().trim() === data.Name.toLowerCase().trim()
        );

        if (isDuplicate) {
            // Mark field as touched so error is displayed
            methods.setValue("Name", data.Name, {
                shouldTouch: true,
                shouldValidate: false,
            });

            // Set error
            methods.setError(
                "Name",
                {
                    type: "manual",
                    message: "A supplier with this name already exists",
                },
                { shouldFocus: true }
            );
            showError("A supplier with this name already exists");
            return;
        }

        // If no duplicate, proceed with creation
        await handleCreateSupplier(data);
    });

    return (
        <Box flex={1}>
            <Breadcrumb />

            <Divider sx={{ position: "sticky", top: 48 }} />

            <Box component={"div"} ml={3} width={700}>
                <FormProvider {...methods}>
                    <form onSubmit={onSubmit}>
                        <Box display={"flex"} gap={2} flexDirection={"column"}>
                            <SupplierConfiguration />
                            <Action api={createSupplierSvc} />
                            <Alert
                                successMessage={createSupplierSvc.isSuccess && "Supplier created successfully!"}
                                sx={{ mt: 3 }}
                                errorMessage={
                                    createSupplierSvc.isError && "Failed to create supplier. Please try again."
                                }
                            />
                        </Box>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
